import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadPhotosQueryAtom = createQueryAtomFactory(
  'customerPortal.loadPhotos',
  (params: { id?: string }) => ({
    load: {
      __args: {
        id: params.id ?? '',
      },
      recyclerFiles: {
        id: true,
        entityType: true,
        parentId: true,
        metadata: true,
      },
    },
  }),
  {
    select: ({ load }) => load?.recyclerFiles ?? [],
  },
);
